"use strict"

import $ from 'jquery';
import {List} from './list.js';

document.addEventListener('DOMContentLoaded', function() {
	$(".js-select2").select2({
		theme: 'bootstrap4',
	});

	let map = L.map('map').setView([41.9, 12.483333], 4);
	const maxAutoZoom = 10;

	let OpenTopoMap = L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
		maxZoom: 14,
		attribution: 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
	});

	OpenTopoMap.addTo(map);

	let popup = L.popup();
	let layer;

	function onEachFeature(feature, layer) {
		layer.bindPopup(`
<div style="width: 160px">
	<dl>
		<dt>Forms</dt>
		<dd>${feature.properties.form_count}</dd>

		<dt>Region</dt>
		<dd>${feature.properties.region_title}</dd>

		<dt>Province</dt>
		<dd>${feature.properties.province_title}</dd>

		<dt>Place</dt>
		<dd>${feature.properties.place_title}</dd>
	</dl>
</div>`);
	}

	let regionPicker = document.querySelector('.js-region-picker');
	let provincePicker = document.querySelector('.js-province-picker');
	let placePicker = document.querySelector('.js-place-picker');
	let dialectClass1Picker = document.querySelector('.js-dialect-class-1-picker');
	let dialectClass2Picker = document.querySelector('.js-dialect-class-2-picker');
	let dialectClass3Picker = document.querySelector('.js-dialect-class-3-picker');

	const buildFilter = function () {
		let filter = [];
		const regionIds = $(regionPicker).select2('data').map(item => item.id);
		const provinceIds = $(provincePicker).select2('data').map(item => item.id);
		const placeIds = $(placePicker).select2('data').map(item => item.id);
		const dialectClass1Ids = $(dialectClass1Picker).select2('data').map(item => item.id);
		const dialectClass2Ids = $(dialectClass2Picker).select2('data').map(item => item.id);
		const dialectClass3Ids = $(dialectClass3Picker).select2('data').map(item => item.id);

		if (regionIds.length > 0) {
			filter.push({
				expression: regionIds,
				field: "region",
				operator: "in",
			});
		}

		if (provinceIds.length > 0) {
			filter.push({
				expression: provinceIds,
				field: "province",
				operator: "in",
			});
		}

		if (placeIds.length > 0) {
			filter.push({
				expression: placeIds,
				field: "place",
				operator: "in",
			});
		}

		if (dialectClass1Ids.length > 0) {
			filter.push({
				expression: dialectClass1Ids,
				field: "dialect_class_1",
				operator: "in",
			});
		}

		if (dialectClass2Ids.length > 0) {
			filter.push({
				expression: dialectClass2Ids,
				field: "dialect_class_2",
				operator: "in",
			});
		}

		if (dialectClass3Ids.length > 0) {
			filter.push({
				expression: dialectClass3Ids,
				field: "dialect_class_3",
				operator: "in",
			});
		}

		return filter;
	};

	document.querySelector(".js-toggle-map").addEventListener("click", () => {
		document.querySelector(".js-map").classList.toggle("map-hidden");
		map.invalidateSize();

		if (layer) {
			map.fitBounds(layer.getBounds(), {maxZoom: maxAutoZoom});
		}
	});

	let tables = document.getElementsByClassName('js-items');

	let effectiveProvinceIds = [];
	let effectiveDialectClass2Ids = [];

	for (let i = 0, len = tables.length; i < len; i++) {
		let list = new List(tables[i]);

		list.updateTableWithInput = function () {
			list.updateTable(
				list.quickSearch.value,
				parseInt(list.pagePicker.value),
				parseInt(list.limitPicker.value),
				list.sortPicker.value,
				list.orderPicker.value,
				list.getFilter().concat(buildFilter())
			);
		};

		list.initTableWithInput = function () {
			list.updateTable(
				list.quickSearch.value,
				1,
				parseInt(list.limitPicker.value),
				list.sortPicker.value,
				list.orderPicker.value,
				list.getFilter().concat(buildFilter())
			);
		};

		list.afterDataLoaded = function (data) {
			if (layer) {
				layer.remove();
			}

			layer = L.geoJSON(data.points, {onEachFeature: onEachFeature}).addTo(map);
			map.flyToBounds(layer.getBounds(), {maxZoom: maxAutoZoom});
		};

		$(regionPicker).on('change', e => {
			const parentIds = $(regionPicker).select2('data').map(item => parseInt(item.id));
			const selectedIds = $(provincePicker).select2('data').map(item => parseInt(item.id));
			$(provincePicker).empty();
			effectiveProvinceIds = [];

			const items = JSON.parse(provincePicker.dataset.items);
			const parents = JSON.parse(provincePicker.dataset.parents);

			for (const pair of parents) {
				if (parentIds.length == 0 || parentIds.includes(pair.region)) {
					const isSelected = selectedIds.includes(pair.province);
					let option = new Option(items[pair.province], pair.province, isSelected, isSelected);
					$(provincePicker).append(option);
					effectiveProvinceIds.push(pair.province);
				}
			}

			$(provincePicker).trigger('change');
		});

		$(provincePicker).on('change', e => {
			let parentIds = $(provincePicker).select2('data').map(item => parseInt(item.id));
			const selectedIds = $(placePicker).select2('data').map(item => parseInt(item.id));
			$(placePicker).empty();

			if (parentIds.length == 0) {
				parentIds = effectiveProvinceIds;
			}

			const items = JSON.parse(placePicker.dataset.items);
			const parents = JSON.parse(placePicker.dataset.parents);

			for (const pair of parents) {
				if (parentIds.length == 0 || parentIds.includes(pair.province)) {
					const isSelected = selectedIds.includes(pair.place);
					let option = new Option(items[pair.place], pair.place, isSelected, isSelected);
					$(placePicker).append(option);
				}
			}

			$(placePicker).trigger('change');
		});

		$(placePicker).on('change', e => {
			list.initTableWithInput();
		});

		$(dialectClass1Picker).on('change', e => {
			const parentIds = $(dialectClass1Picker).select2('data').map(item => parseInt(item.id));
			const selectedIds = $(dialectClass2Picker).select2('data').map(item => parseInt(item.id));
			$(dialectClass2Picker).empty();
			effectiveDialectClass2Ids = [];

			const items = JSON.parse(dialectClass2Picker.dataset.items);
			const parents = JSON.parse(dialectClass2Picker.dataset.parents);

			for (const pair of parents) {
				if (parentIds.length == 0 || parentIds.includes(pair.dialect_class_1)) {
					const isSelected = selectedIds.includes(pair.dialect_class_2);
					let option = new Option(items[pair.dialect_class_2], pair.dialect_class_2, isSelected, isSelected);
					$(dialectClass2Picker).append(option);
					effectiveDialectClass2Ids.push(pair.dialect_class_2);
				}
			}

			$(dialectClass2Picker).trigger('change');
		});

		$(dialectClass2Picker).on('change', e => {
			let parentIds = $(dialectClass2Picker).select2('data').map(item => parseInt(item.id));
			const selectedIds = $(dialectClass3Picker).select2('data').map(item => parseInt(item.id));
			$(dialectClass3Picker).empty();

			if (parentIds.length == 0) {
				parentIds = effectiveDialectClass2Ids;
			}

			const items = JSON.parse(dialectClass3Picker.dataset.items);
			const parents = JSON.parse(dialectClass3Picker.dataset.parents);
			let itemIds = [];

			for (const pair of parents) {
				if (parentIds.length == 0 || parentIds.includes(pair.dialect_class_2)) {
					if (!itemIds.includes(pair.dialect_class_3)) {
						const isSelected = selectedIds.includes(pair.dialect_class_3);
						let option = new Option(items[pair.dialect_class_3], pair.dialect_class_3, isSelected, isSelected);
						$(dialectClass3Picker).append(option);
						itemIds.push(pair.dialect_class_3);
					}
				}
			}

			$(dialectClass3Picker).trigger('change');
		});

		$(dialectClass3Picker).on('change', e => {
			list.initTableWithInput();
		});
	}
});
